export default __webpack_public_path__ + "static/media/image4.fc9572ff.jpg";